import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var ConfigService = /** @class */ (function () {
    function ConfigService(http) {
        this.http = http;
    }
    ConfigService.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.http.get('config.json')
                .subscribe(function (json) {
                _this.config = json;
                resolve();
            });
        });
    };
    ConfigService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ConfigService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return ConfigService;
}());
export { ConfigService };
//# sourceMappingURL=config.service.js.map